import { useUserSettings, useUserDesktopConfig } from './useUserSettings';

export interface AppSettings {
  [key: string]: any;
}

// Fast Supabase-backed settings hook
export const useSettings = (appId: string, defaultSettings: AppSettings = {}) => {
  return useUserSettings(appId, defaultSettings);
};

// Fast Supabase-backed desktop config hook
export const useDesktopConfig = () => {
  return useUserDesktopConfig();
};